<script setup lang="ts">
import { fetchSponsors } from '~/lib/sponsor';

definePageMeta({
  title: "協賛企業",
})

const { data: sponsors } = useAsyncData(
  `sponsors`,
  () => fetchSponsors(),
  { server: true, lazy: false }
)
</script>

<template>
  <article class="flex flex-col items-center max-w-[900px] mx-auto px-[8px] bg-white pb-16 -mb-8">
    <Ribbon class="mt-6 mb-8 text-md md:text-2xl">
      協賛企業様のご紹介
    </Ribbon>

    <p class="mb-8 text-center">
      本年度のコスモス祭は、以下の企業様にご協賛いただいております。<br />
      ※ 順不同
    </p>

    <p class="grid grid-cols-1 max-w-[400px] lg:grid-cols-2 lg:max-w-[700px] gap-y-8 gap-x-4">
      <template v-if="sponsors !== undefined">
        <div v-for="sponsor in sponsors" class="grid grid-rows-[1fr_auto]">
          <template v-if="sponsor['形式'] === 'ロゴ'">
            <div class="grid place-items-center">
              <img class="max-h-30 lg:max-h-none" :src="`/2025/img/sponsor/${sponsor['企業名']}.jpg`" decoding="async"
                loading="lazy" />
            </div>
            <p class="text-2xl lg:text-3xl text-center">
              {{ sponsor['企業名'] }}様
            </p>
            <p v-if="sponsor['企業名_2']" class="text-2xl lg:text-3xl text-center">
              {{ sponsor['企業名_2'] }}様
            </p>
          </template>
          <template v-else>
            <p class="text-2xl lg:text-3xl text-center">
              {{ sponsor['企業名'] }}様
            </p>
            <p v-if="sponsor['企業名_2']" class="text-2xl lg:text-3xl text-center">
              {{ sponsor['企業名_2'] }}様
            </p>
          </template>
        </div>
      </template>
    </p>
  </article>
</template>